jQuery($ => {
  class DonationForm {
    constructor(element) {
      this._        = element;
      this._element = $(element);

      this.init();
    }

    setupProps() {
      this._content    = this._element.find('.m-donation-form__content');
      this._form       = this._element.find('form');
      this._fields     = this._element.find('.m-donation-form__field');
      this._visibleFields = this._element.find('.m-donation-form__field:not(.m-donation-form__field--hidden)');
      this._toggle     = this._fields.filter('.m-donation-form__field--toggle-switch');
      this._radios     = this._visibleFields.filter('.m-donation-form__field--large-radio-buttons');
      this._filter     = this._fields.filter('.m-donation-form__filter').find('.a-select');
      this._filterable = this._fields.filter('.m-donation-form__filterable').find('.a-select');
      this._button     = this._element.find('.m-donation-form__button, .m-donation-form__sublink, .m-account-modal__cta, .m-account-details__button');
      this._link       = this._button.filter('a');
      this._next       = this._button.filter('[type="button"]');
      this._submit     = this._button.filter('[type="submit"]');
      this._actions    = this._submit.filter('[name]');
      this._ajax       = this._form.attr('ajax');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupProps();
      this.setupHandlers();
      if ( this._ajax ) this.setupValidation();
      this._element.trigger( 'init', this );
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      if ( this._actions.length && this._ajax ) {
        this._submit.on( 'click', this.handleSubmit );
      } else {
        this._form.on( 'submit', this._ajax ? this.handleSubmit : this.handleNext );
      }
      this._link.on( 'click', this.handleLinkClick );
      this._next.on( 'click', this.handleNextClick );
      this._filter.on( 'chooseSelectOption', this.handleFilter );
      this._toggle.on( 'change', this.handleToggleChange );

      // Add handler for radio button changes to clear validation errors
      const $allRadioInputsInGroup = this._radios.find('input[type="radio"]');
      $allRadioInputsInGroup.on('change', this.clearRadioErrors);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Validation
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupValidation() {
      $.validator.addMethod("customemail", 
          function(value, element) {
              return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
          }, 
          "Please enter a valid email address."
      );

      var validator = this._form.validate({
        rules: {
            email: {
              customemail: true
            },
            billing_email: {
              customemail: true
            },
            billing_phone: {
                phoneUS: true
            },
            zip: {
                zipcodeUS: true
            }
        },
        ignore: function (index, el) {
          if ($(el).hasClass('a-select__native') && !$(el).closest('.m-field--hidden')[0]) {
              return false;
          }

          return $(el).is(':hidden');
        },
        // errorClass: 'm-field--error',
        errorPlacement: function(error, element) {
            error.appendTo( $(element).closest(".m-field,.t-checkout__field") );
        },
        highlight: function(element, errorClass, validClass) {
            $(element).closest(".m-field,.t-checkout__field").addClass('m-field--error').removeClass(validClass);
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element).closest(".m-field,.t-checkout__field").removeClass('m-field--error').addClass(validClass);
        }
      });

      this._form.find('.a-select').on('chooseSelectOption', function() {
        validator.element($(this).find('select'));
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Clear Select
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleClearSelect = ($select) => {
      $select.addClass('a-select--unset');
      $select.find('.a-select__native').val('');
      $select.find('.a-select__item')
        .removeClass('a-select__item--selected')
        .attr('aria-selected', 'false');

      $select.find('.a-select__value').text('');

      $select.attr('aria-label', $select.data('label'));
        
      $select.trigger('clearSelect');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Link Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleLinkClick = (e) => {
      e.preventDefault();
      let _linkForm = this._form.clone().hide();

      _linkForm.appendTo($(document.body));
      _linkForm.attr('method', 'GET');
      _linkForm.attr('action', this._link.attr('href'));
      _linkForm.trigger('form_link', this._link.attr('id'));
      _linkForm.submit();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Other Amount
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOtherAmount = () => {
      const $visibleFields = this._element.find('.m-donation-form__field:not(.m-donation-form__field--hidden)');
      const $radios     = $visibleFields.filter('.m-donation-form__field--large-radio-buttons');
      
      // Validation logic for "other" amount
      const $otherRadioOption = $radios.find('input[type="radio"][value="other"]');
      const $otherInput = $radios.find('.m-large-radio-buttons__other');

      $radios.removeClass('m-field--error'); // Clear previous error class
      $radios.find('.error').remove(); // Clear previous error messages

      if ($otherRadioOption.is(':checked') && !$otherInput.val()) {
        $radios.addClass('m-field--error');
        $radios.append(`<div class="error">Please enter an amount</div>`);
        return false;
      } else {
        // This line was in the original main.js logic to hide the text field if shown.
        $radios.find('.m-large-radio-buttons__text-field').removeClass('m-large-radio-buttons__text-field--show');
        return true;
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Clear Radio Errors
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    clearRadioErrors = () => {
      this._radios.removeClass('m-field--error');
      this._radios.find('.error').remove();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Next Click
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleNextClick = (e) => {
      e.preventDefault();

      if (!this.handleOtherAmount()) return;

      this.handleGoTo(this._next.attr('name'));
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Filter
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleFilter = (e, label, value) => {
      let items = this._filterable.find('[data-group]'),
          $show = items.filter(function(){
            return $(this).data('group').includes(value);
          });

      this.handleClearSelect(this._filterable);

      items.addClass('a-select__item--hidden');
      $show.removeClass('a-select__item--hidden');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Toggle Change
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleToggleChange = (e, name, value) => {
      let $fields = this._fields.filter(`[data-conditional="${name}"]`);

      $fields.addClass('m-donation-form__field--hidden');
      $fields.filter(`[data-conditional-value="${value}"]`).removeClass('m-donation-form__field--hidden');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Submit
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleSubmit = (e) => {
      e.preventDefault();

      if (!this.handleOtherAmount()) return;

      if ( !this._form.valid() ) return;

      $('.woocommerce-error').remove();
      $('.woocommerce-message').remove();

      this._element.block({message: null, overlayCSS: {background: '#fff', opacity: 0.6}});

      let formdata = this._form.serializeArray();
      let data = {
        post_data: $( 'form.checkout' ).serialize()
      };

      $(formdata).each(function(index, obj){
          data[obj.name] = obj.value;
      });

      let $button = $(e.currentTarget).filter('button[name]');
      if ( $button.length ) {
        data[$button.attr('name')] = $button.attr('value');
      }

      $.ajax({
        type   : 'POST',
        url    : wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', this._ajax ),
        data   : data,
        success: this.handleResponse,
      });
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Response
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleResponse = (response) => {
      this._element.unblock();

      let success = response.success === undefined || response.success;
      let data    = response.data || {};

      if ( success ) {
        this.handleSuccess(data);
      } else {
        this.handleError(data);
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Success
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleSuccess = (response) => {
      if ( response.fragments ) {
        $.each( response.fragments, function ( key, value ) {
          if (value) $( key ).replaceWith( value );
        } );
      }
      response.next ? this.handleGoTo(response.next) : this.handleNext();

      if ( response.reinit ) {
        let reinit = typeof response.reinit === 'string' ? $(`#${response.reinit}`) : $(`#${response.next}`);
        reinit.donation_form('init');
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Error
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleError = (response) => {
      this._content.prepend('<ul class="woocommerce-error"><li>' + response + '</li></ul>');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Hide
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleHide = () => {
      this._element.addClass('m-donation-form--hidden');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Show
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleShow = () => {
      this._element.removeClass('m-donation-form--hidden');
      this._element.find('.woocommerce-input-wrapper select').select2();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Reset
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleReset() {
      if ( !this._form.length ) return;
      this._form[0].reset();
      this.handleClearSelect(this._form.find('.a-select'));
      this._radios.large_radio_buttons('handleReset');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Go To
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleGoTo = (id) => {
      $('.woocommerce-error').remove();
      $('.woocommerce-message').remove();

      let goto = $(`#${id}`);

      if ( !goto.length ) return;
      
      this._form.trigger( 'form_step', id );

      this.handleHide();
      goto.donation_form('handleShow');
      goto.donation_form('handleReset');
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Next
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleNext = (e) => {
      if ( e ) e.preventDefault();

      let next = this._element.next();

      while ( next.length && next.data('skip-next') ) {
        next = next.next();
      }

      if ( !next.length ) return;

      let id = next.attr('id');

      this.handleGoTo(id);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Previous
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handlePrevious = () => {
      let prev = this._element.prev();

      while ( prev.length && prev.data('skip-back') ) {
        prev = prev.prev();
      }

      if ( !prev.length ) return;

      let id = prev.attr('id');
      this.handleGoTo(id);
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.donation_form = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].donation_form = new DonationForm(_[i], opt);
      else
        ret = _[i].donation_form[opt].apply(_[i].donation_form, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-donation-form').donation_form();
});